export const searchInPath = (char: string, path: string) => {
  path = path.replace(/\/+$/, '');
  return path.endsWith(char);
};
